'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { ROUTES } from '@/lib/constants/routes'
import { useMaintenanceStore } from '@/stores/useMaintenanceStore'

export function MaintenanceHandler() {
  const router = useRouter()
  const { shouldRedirectToMaintenance, resetMaintenanceState } = useMaintenanceStore()

  useEffect(() => {
    if (shouldRedirectToMaintenance) {
      resetMaintenanceState()
      router.replace(ROUTES.TENANT_MAINTENANCE)
    }
  }, [shouldRedirectToMaintenance, resetMaintenanceState, router])

  return null
}
